import { render, staticRenderFns } from "./addLabelgroup.vue?vue&type=template&id=44d686dc&scoped=true"
import script from "./addLabelgroup.vue?vue&type=script&lang=js"
export * from "./addLabelgroup.vue?vue&type=script&lang=js"
import style0 from "./addLabelgroup.vue?vue&type=style&index=0&id=44d686dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d686dc",
  null
  
)

export default component.exports